export default __webpack_public_path__ + "static/media/455.2429dfab.jpg";